import { z } from "zod";

export const EditableOptionSchema = z.object({
  text: z.string(),
  isCorrect: z.boolean(),
});

/** An uploaded picture, already stored; all null while the author has picked none. */
export const EditableImageSchema = z.object({
  kind: z.literal("image"),
  id: z.string().nullable(),
  src: z.string().nullable(),
  filename: z.string().nullable(),
});

/**
 * A clip the author picked, already stored; all null while they have picked none. A clip taken from
 * the phonics library carries the sound it records, which pronunciation scoring needs: it belongs
 * to the clip rather than beside it, so clearing one clears both. Defaulted for drafts written
 * before the field existed.
 */
export const EditableAudioSchema = z.object({
  kind: z.literal("audio"),
  id: z.string().nullable(),
  src: z.string().nullable(),
  filename: z.string().nullable(),
  phonemeId: z.string().nullable().default(null),
});

export const EditableValueSchema = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("text"), text: z.string() }),
  z.object({ kind: z.literal("multiline"), text: z.string() }),
  z.object({ kind: z.literal("options"), options: z.array(EditableOptionSchema) }),
  EditableImageSchema,
  EditableAudioSchema,
]);

export const EditableFieldSchema = z.object({
  key: z.string(),
  label: z.string(),
  value: EditableValueSchema,
});

export type EditableOption = z.infer<typeof EditableOptionSchema>;
export type EditableImage = z.infer<typeof EditableImageSchema>;
export type EditableAudio = z.infer<typeof EditableAudioSchema>;
export type EditableValue = z.infer<typeof EditableValueSchema>;
export type EditableField = z.infer<typeof EditableFieldSchema>;
